<label [for]="inputId + 'Start'" class="form-label">{{ label }}</label>
<div class="input-group">
  <span class="input-group-text"><i class="bi bi-clock-history"></i></span>
  <select [id]="inputId + '-shortcut'" class="form-select period-shortcut" (change)="onDateChange()" [(ngModel)]="dateSelector" [ngModelOptions]="{standalone: true}">
    <option value="today">Today</option>
    <option value="yesterday">Yesterday</option>
    <option value="this-week">This Week</option>
    <option value="last-week">Last Week</option>
    <option value="this-month">This Month</option>
    <option value="last-month">Last Month</option>
    <option value="this-year">This Year</option>
    <option value="last-year">Last Year</option>
    <option value="custom">Custom</option>
  </select>

  <span class="input-group-text"><i class="bi bi-calendar-date"></i></span>
  <input type="date" class="form-control date" [id]="inputId + 'Start'" placeholder="Start Date"
    [(ngModel)]="dateFromSelector" [ngModelOptions]="{standalone: true}" (blur)="onCustomDateChange()">

  <span class="input-group-text"><i class="bi bi-calendar-date"></i></span>
  <input type="date" class="form-control date" [id]="inputId + 'End'" placeholder="End Date" [(ngModel)]="dateToSelector" [ngModelOptions]="{standalone: true}"
    (blur)="onCustomDateChange()">

  @if (showTimezone) {
    <span class="input-group-text"><i class="bi bi-globe"></i></span>
    <select [id]="inputId + '-gmt'" class="form-select" [(ngModel)]="timezone" [ngModelOptions]="{standalone: true}" (change)="onDateChange()">
      @for (timezone of getTimezones(); track timezone) {
        <option
          [value]="timezone">{{ getTimezoneOffsetLabel(timezone) + (shortTimezone ? '' : 'timezone.' + timezone  | translate) }}
        </option>
      }
    </select>
  }
</div>
